import { post as apiPost } from './apiService';
import { AdditionalContent, AdditionalContentSearchRequest } from '../types/additionalContent';
import { Badge } from '../types/index';

export interface CompleteAdditionalContentResponse {
  success: boolean;
  badgesEarned?: Badge[];
  alreadyCompleted: boolean;
}

// Search for additional content
export async function searchAdditionalContent(request: AdditionalContentSearchRequest): Promise<AdditionalContent[]> {
  return apiPost<AdditionalContent[]>('/additional-content/search', request);
}

// Complete additional content and potentially earn badges
// profileId identifies the user to assign the badge to (required for backend to assign badge)
// Handles both direct response and wrapped response (e.g. { status, message, data })
export async function completeAdditionalContent(
  additionalContentId: string,
  progress: number,
  profileId?: string
): Promise<CompleteAdditionalContentResponse> {
  try {
    const body: { progress: number; profileId?: string } = { progress };
    if (profileId) body.profileId = profileId;
    const raw = await apiPost<CompleteAdditionalContentResponse | { data?: CompleteAdditionalContentResponse }>(
      `/additional-content/${additionalContentId}/complete`,
      body
    );
    const response =
      raw && typeof raw === 'object' && 'data' in raw && raw.data != null
        ? raw.data
        : (raw as CompleteAdditionalContentResponse);
    return {
      success: response.success ?? false,
      alreadyCompleted: response.alreadyCompleted ?? false,
      badgesEarned: response.badgesEarned ?? [],
    };
  } catch (error) {
    console.error(`Failed to complete additional content ${additionalContentId}:`, error);
    // Return a safe default response on error
    return { success: false, alreadyCompleted: false, badgesEarned: [] };
  }
}

export const additionalContentService = {
  searchAdditionalContent,
  completeAdditionalContent
};
